import {
  Typography,
  IconButton,
  Box,
  Divider,
  Grid,
  CardMedia,
} from "@mui/material";
import { useContext } from "react";
import { LayoutsConfig, MainContext } from "../context/MainContextProvider";
import { MdOutlineChevronLeft } from "react-icons/md";
import AlarmNotification from "./AlarmNotification";
// import LogoROP from "../../assets/faviconRop.ico";
import LogoROP from "../../assets/logo-rop/ROP_marca-02.png";
import TuneIcon from "@mui/icons-material/Tune";

export default function AsideMenuHeader(props: {
  isShrunken: boolean;
  setIsShrunken: (isShrunken: boolean) => void;
  cantShowShrinkButton?: boolean;
  onClickTuneIcon: () => void;
  isDashboard: boolean;
}) {
  const { theme, user, layout } = useContext(MainContext);
  const {
    isShrunken,
    setIsShrunken,
    cantShowShrinkButton,
    onClickTuneIcon,
    isDashboard,
  } = props;
  const toggleShrink = () => {
    setIsShrunken(!isShrunken);
  };
  return (
    <Box
      sx={{
        textAlign: "start",
        backgroundColor: "transparent",
        padding: "10px",
      }}
    >

      {!isShrunken && layout == LayoutsConfig.LayoutOne && (
        <Grid container sx={{ marginTop: { xs: 2 } }}>
          <CardMedia
            component="img"
            alt="Minha Imagem"
            sx={{
              height: { xs: 100, md: 80 },
              objectFit: "cover",
            }}
            image={LogoROP}
          />
        </Grid>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: isShrunken ? "column-reverse" : "row",
          alignItems: "center",
          justifyContent: isShrunken ? "center" : "space-between",
        }}
      >
        {!isShrunken && (
          <Typography
            sx={{
              fontSize: "20px",
              color: layout == LayoutsConfig.LayoutTwo ? "#FFF" : undefined
            }}
          >
            {user?.name}
          </Typography>
        )}
        <Box>
          {layout == LayoutsConfig.LayoutOne &&
            <AlarmNotification />}
          {isDashboard && (
            <IconButton
              color="inherit"
              onClick={() => {
                onClickTuneIcon();
              }}
              sx={{ padding: "5px" }}
            >
              <TuneIcon
                style={{
                  transition: "transform 0.3s ease-in-out",
                  color: layout == LayoutsConfig.LayoutOne ? theme.iconsColor : "#8F969E",
                }}
              />
            </IconButton>
          )}
        </Box>
        {((layout == LayoutsConfig.LayoutTwo && !isShrunken) || layout == LayoutsConfig.LayoutOne) &&
          <IconButton
            sx={{
              border: layout == LayoutsConfig.LayoutOne ? "1px solid #656C72" : "none",
              padding: "5px",
              "&:hover": {
                border: layout == LayoutsConfig.LayoutOne ?  "1px solid #656C72" : "none",
              },
              marginBottom: isShrunken ? "30px" : "",
              display: cantShowShrinkButton ? "none" : undefined,
            }}
            onClick={toggleShrink}
          >
            <MdOutlineChevronLeft
              style={{
                width: layout == LayoutsConfig.LayoutOne ? "18px" : "24px" ,
                height: layout == LayoutsConfig.LayoutOne ? "18px" : "24px",
                transform: isShrunken ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease-in-out",
                
              }}
              color={layout == LayoutsConfig.LayoutOne ? theme.iconsColor : "#FFF"}
            />
          </IconButton>}
      </Box>
      {!isShrunken && (
        <Typography
          sx={{
            fontSize: "10px",
            marginBottom: "10px",
            color: layout == LayoutsConfig.LayoutTwo ? "#FFF" : undefined
          }}
        >
          {"Perfil do usuário"}
        </Typography>
      )}
      <Divider
        style={{
          backgroundColor: theme.secondaryTextColor,
        }}
        variant="middle"
      />
    </Box>
  );
}
